<prof-topnav-progressive-profile></prof-topnav-progressive-profile>

<div class="center-container">
  <mat-spinner class="data-spinner" color="accent" *ngIf="!profile"></mat-spinner>
  <form class="profile-form" [formGroup]="profileForm" *ngIf="profile && !isInternal" (ngSubmit)="save()">
    <div class="container">
      <div class="detail-container-1">
        <div class="header-buttons">
          <div class="profile">
            <p class="your-profile">{{ 'EDIT_PROFILE.your_profile' | translate }}</p>  
          </div>
          <div class="button">
            <button class="changepwbtn" mat-stroked-button color="primary" type="button"  [disabled]="isChangePasswordDisabled"
              (click)="changePassword()">
              <ng-container *ngIf="!isChangePasswordDisabled; else loading">
                {{ 'EDIT_PROFILE.change_password' | translate }}
              </ng-container>
              <ng-template #loading>
                <span class="change-pwd-inprocess">
                  {{ 'EDIT_PROFILE.change_password' | translate }} <mat-spinner diameter="20"></mat-spinner>
                </span>
              </ng-template>
            </button>
            <button
              mat-stroked-button
              color="warn"
              *ngIf="!timeForDeletion"
              class="delete-account-btn"
              type="button"
              (click)="deleteUser()"
              [disabled]="isDeleteUserDisabled"
            >
              <ng-container *ngIf="!isDeleteUserDisabled; else loading">
                {{ 'EDIT_PROFILE.delete_account' | translate }}
              </ng-container>
              <ng-template #loading>
                <span class="change-pwd-inprocess">
                  {{ 'EDIT_PROFILE.delete_account' | translate }} <mat-spinner diameter="20"></mat-spinner>
                </span>
              </ng-template>
            </button>
          </div>
        </div>        
      </div>
      <div class="detail-container-2">
        <div class="personal">
          <p class="personal-details">{{ 'EDIT_PROFILE.personal_details' | translate }}</p>
        </div>
      </div>
      <div class="detail-container-3">
        <div class="names">
          <div class="firstname">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.first_name' | translate }}</mat-label>
              <input
                matInput
                [maxlength]="NAME_MAX_LENGTH"
                formControlName="firstName"
                placeholder="{{ 'EDIT_PROFILE.first_name' | translate }}"
                [disabled]="isFederated"
                required
              />
              <mat-error *ngIf="profileForm.get('firstName').hasError('maxLengthTrimmed')">
                {{ 'EDIT_PROFILE.first_name_max_length' | translate }}
              </mat-error>
              <mat-error *ngIf="profileForm.get('firstName').invalid && !profileForm.get('firstName').hasError('maxLengthTrimmed')">
                {{ 'EDIT_PROFILE.invalid_firstName' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="lastname">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.last_name' | translate }}</mat-label>
              <input
                matInput
                [maxlength]="NAME_MAX_LENGTH"
                class="lnameInput"
                formControlName="lastName"
                placeholder="{{ 'EDIT_PROFILE.last_name' | translate }}"
                [disabled]="isFederated"
                required
              />
              <mat-error *ngIf="profileForm.get('lastName').hasError('maxLengthTrimmed')">
                {{ 'EDIT_PROFILE.last_name_max_length' | translate }}
              </mat-error>
              <mat-error *ngIf="profileForm.get('lastName').invalid && !profileForm.get('lastName').hasError('maxLengthTrimmed')">
                {{ 'EDIT_PROFILE.invalid_lastName' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="email-country">
          <div class="email" >
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.email' | translate }}</mat-label>
              <input
                matInput
                class="emailInput"
                formControlName="email"
                placeholder="{{ 'EDIT_PROFILE.email' | translate }}"
                disabled
                required
              />
            </mat-form-field>
          </div>
          <div class="country" >
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.country' | translate }}</mat-label>
              <mat-select
                formControlName="country"
                required
                (selectionChange)="onCountryChange()"
              >
                <mat-option *ngFor="let c of countries" [value]="c.value">
                  {{ c.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="codes">
          <div class="code">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.postal_code' | translate }}</mat-label>
              <input
                matInput
                *ngIf="postMask !== ''"
                class="postalcodeinput"
                formControlName="postalCode"
                placeholder="{{ 'EDIT_PROFILE.postal_code' | translate }}"
                mask="{{ postMask }}"
                required
              />
              <input
                matInput
                *ngIf="postMask === ''"
                class="postalcodeinput"
                formControlName="postalCode"
                placeholder="{{ 'EDIT_PROFILE.postal_code' | translate }}"
              />
              <mat-error *ngIf="profileForm.get('postalCode').invalid || profileForm.get('postalCode').hasError('invalidCombination')">
                {{ 'EDIT_PROFILE.postal_code_required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="job-function">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.job_function' | translate }}</mat-label>
              <mat-select
                formControlName="personaID"
                placeholder="{{ 'EDIT_PROFILE.job_function' | translate }}"
                required
                (selectionChange)="onChange()"
              >
                <mat-option *ngFor="let p of personas" [value]="p.id">
                  {{ convertLanguage(p.value) }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="profileForm.get('personaID').invalid && (profileForm.get('personaID').touched || profileForm.get('personaID').dirty)">
                {{ 'EDIT_PROFILE.job_function_required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="job">
          <div class="phone">
            <div class="country-code">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.country_code' | translate }}</mat-label>
                <mat-select formControlName="phoneCode">
                  <mat-select-trigger aria-label="branches-select-trigger">
                    {{ profileForm.get('phoneCode').value }}
                  </mat-select-trigger>
                  <mat-option *ngFor="let code of phoneCodes" [value]="code.dial_code">
                    {{ code.dial_code }} {{ code.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="phone-number">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label class="mat-label" [ariaRequired]>{{ 'EDIT_PROFILE.phone_number' | translate }}</mat-label>
                <input
                  matInput
                  *ngIf="phoneMask !== ''"
                  class="phoneInput"
                  formControlName="phone"
                  placeholder="{{ 'EDIT_PROFILE.phone_number' | translate }}"
                  mask="{{ phoneMask }}"
                />
                <input
                  matInput
                  *ngIf="phoneMask === ''"
                  class="phoneInput"
                  formControlName="phone"
                  placeholder="{{ 'EDIT_PROFILE.phone_number' | translate }}"
                />
                <mat-error *ngIf="profileForm.get('phone').invalid && (profileForm.get('phone').touched || profileForm.get('phone').dirty)">
                  {{ 'EDIT_PROFILE.invalid_phone' | translate }}
                </mat-error>
              </mat-form-field>
            </div>    
          </div> 
        </div>
      </div>
      <div class="detail-container-4">
        <div class="marketing">
          <mat-checkbox
            class="contact"
            formControlName="canWeShareInfo"
            color="primary"
            (change)="onChange()"
          >
            {{ 'EDIT_PROFILE.ok_to_contact' | translate }}
          </mat-checkbox>
        </div>
      </div>
      <div class="detail-container-5">
        <div class="discard">
          <button
            class="changepwbtn"
            mat-stroked-button
            color="primary"
            [disabled]="disableForm()"
            type="button"
            (click)="resetProfile()"
          >
            {{ 'EDIT_PROFILE.discard' | translate }}
          </button>
          <ng-template #Loader>
            <div class="spinnercontainer">
              <mat-spinner
                mode="indeterminate"
                diameter="36"
                [strokeWidth]="4"
                color="accent"
              ></mat-spinner>
            </div>
          </ng-template>
            <button
              class="savebutton"
              mat-raised-button
              color="primary"
              [disabled]="disableForm()"
              type="submit"
            >
              {{ 'EDIT_PROFILE.save' | translate }}
            </button>
        </div>
      </div>
    </div>      
  </form>
</div>
<div class="spinnerContainer" *ngIf="saving">
  <mat-spinner class="data-spinner" color="accent" *ngIf="saving"></mat-spinner>
</div>

<prof-copyright></prof-copyright>